import * as yup from 'yup';
import { StatusPill } from '../../component/common/status-pill/StatusPill';
import { RowActionsDropdown } from '../../component/common/table/action-dropdown/RowActionsDropdown';

const TYPE_OPTIONS = [
  { key: 'PERCENTAGE', label: 'Percentage Off', value: 'PERCENTAGE', active: true },
  { key: 'FIXED', label: 'Fixed Amount Off', value: 'FIXED', active: true },
  { key: 'FREE_DELIVERY', label: 'Free Delivery', value: 'FREE_DELIVERY', active: true }
];

const formatDiscount = (type, value) => {
  if (type === 'FREE_DELIVERY') return 'Free delivery';
  if (type === 'PERCENTAGE') return `${value}%`;
  return `R${value}`;
};

export const getCouponColumnDefinition = (onEdit, onView, onDelete, onViewLog) => [
  {
    id: 'code',
    accessorKey: 'code',
    header: 'Code',
    size: 140,
    minSize: 100,
    filterFn: 'tableFilterFn',
    cell: ({ row }) => <span className="coupon-code">{row.original.code}</span>
  },
  {
    id: 'discount',
    header: 'Discount',
    size: 140,
    minSize: 110,
    accessorFn: (row) => formatDiscount(row.discountType, row.discountValue),
    cell: ({ row }) => formatDiscount(row.original.discountType, row.original.discountValue)
  },
  {
    id: 'usage',
    header: 'Usage',
    size: 90,
    minSize: 70,
    accessorFn: (row) => row.usageCount ?? 0,
    cell: ({ row }) => (
      <span>
        {row.original.usageCount ?? 0}
        {row.original.usageLimit != null && (
          <span style={{ color: 'var(--text-gray)' }}> / {row.original.usageLimit}</span>
        )}
      </span>
    )
  },
  {
    id: 'consultantName',
    accessorKey: 'consultantName',
    header: 'Assigned To',
    size: 160,
    minSize: 120,
    filterFn: 'tableFilterFn',
    cell: ({ row }) =>
      row.original.consultantName ?? <span style={{ color: 'var(--text-gray)' }}>-</span>
  },
  {
    id: 'expiresAt',
    accessorKey: 'expiresAt',
    header: 'Expires',
    size: 110,
    minSize: 90,
    cell: ({ row }) =>
      row.original.expiresAt
        ? new Date(row.original.expiresAt).toLocaleDateString('en-ZA')
        : <span style={{ color: 'var(--text-gray)' }}>Never</span>
  },
  {
    id: 'active',
    accessorKey: 'active',
    header: 'Status',
    size: 100,
    minSize: 80,
    cell: ({ row }) => (
      <StatusPill type={row.original.active ? 'active' : 'inactive'}>
        {row.original.active ? 'Active' : 'Inactive'}
      </StatusPill>
    )
  },
  {
    id: 'actions',
    header: '',
    size: 40,
    minSize: 40,
    maxSize: 40,
    enableSorting: false,
    disableExport: true,
    cell: ({ row }) => {
      const actions = [
        onViewLog && { label: 'View Log', value: 'log', onSelect: () => onViewLog(row.original) },
        onEdit && { label: 'Edit', value: 'edit', onSelect: () => onEdit(row.original) },
        onDelete && { label: 'Delete', value: 'delete', onSelect: () => onDelete(row.original) }
      ].filter(Boolean);
      return <RowActionsDropdown row={row} actions={actions} />;
    }
  }
];

export const COUPON_TABS = (consultants = []) => {
  const consultantOptions = [
    { key: 'none', label: 'None (standalone)', value: '', active: true },
    ...consultants.map((c) => ({
      key: c.id,
      label: `${c.firstName} ${c.lastName}`,
      value: c.id,
      active: true
    }))
  ];

  return [
    {
      label: 'Details',
      fields: [
        {
          type: 'input',
          name: 'code',
          label: 'Coupon Code',
          required: true,
          colSpan: 2,
          validation: yup.string().required('Required')
        },
        {
          type: 'select',
          name: 'discountType',
          label: 'Discount Type',
          defaultValue: 'PERCENTAGE',
          options: TYPE_OPTIONS,
          validation: yup.string().required('Required')
        },
        {
          type: 'decimal',
          name: 'discountValue',
          label: 'Discount Value',
          validation: yup.number().nullable().optional()
        },
        {
          type: 'number',
          name: 'usageLimit',
          label: 'Usage Limit',
          validation: yup.number().nullable().optional()
        },
        {
          type: 'date',
          name: 'expiresAt',
          label: 'Expiry Date',
          validation: yup.string().nullable().optional()
        },
        {
          type: 'yesno',
          name: 'active',
          label: 'Active',
          defaultValue: true,
          validation: yup.boolean().optional()
        },
        {
          type: 'select',
          name: 'consultantId',
          label: 'Assign to Consultant',
          options: consultantOptions,
          validation: yup.string().nullable().optional()
        }
      ]
    }
  ];
};
